import {TranslationModel} from "Core/Controls/BaseControl/Models/TranslationModel";

export class PcfGroup {
    constructor(public Id: number, public Name: string, public NameTranslation: string, public NameTranslations: Array<TranslationModel>) {
    }
}